/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export const SHOW_PERMISSION_DENIED = 'SHOW_PERMISSION_DENIED';
export const HIDE_PERMISSION_DENIED = 'HIDE_PERMISSION_DENIED';

// GLOBALDATA
export const LOADING_GLOBALDATA = 'LOADING_GLOBALDATA';
export const LOADED_GLOBALDATA = 'LOADED_GLOBALDATA';
export const ERROR_GLOBALDATA = 'ERROR_GLOBALDATA';

// UPGRADE MODAL
export const SHOW_UPGRADE_MODAL = 'SHOW_UPGRADE_MODAL';
export const HIDE_UPGRADE_MODAL = 'HIDE_UPGRADE_MODAL';

// INITIATIVE
export const LOADING_INITIATIVE = 'LOADING_INITIATIVE';
export const LOADED_INITIATIVE = 'LOADED_INITIATIVE';
export const ERROR_INITIATIVE = 'ERROR_INITIATIVE';

// CUSTOM METRIC GROUPS
export const LOADING_CUSTOM_METRIC_GROUPS = 'LOADING_CUSTOM_METRIC_GROUPS';
export const LOADED_CUSTOM_METRIC_GROUPS = 'LOADED_CUSTOM_METRIC_GROUPS';
export const ERROR_CUSTOM_METRIC_GROUPS = 'ERROR_CUSTOM_METRIC_GROUPS';

// REPORTING FRAMEWORKS / SDGAP
export const LOADING_REPORTING_FRAMEWORKS = 'LOADING_REPORTING_FRAMEWORKS';
export const LOADED_REPORTING_FRAMEWORKS = 'LOADED_REPORTING_FRAMEWORKS';
export const ERROR_REPORTING_FRAMEWORKS = 'ERROR_REPORTING_FRAMEWORKS';

// Blueprint
export const LOADING_BLUEPRINT = 'LOADING_BLUEPRINT';
export const LOADED_BLUEPRINT = 'LOADED_BLUEPRINT';
export const ERROR_BLUEPRINT = 'ERROR_BLUEPRINT';

// Blueprint Questions
export const LOADING_INITIATIVE_BLUEPRINT_QUESTIONS = 'LOADING_INITIATIVE_BLUEPRINT_QUESTIONS';
export const LOADED_INITIATIVE_BLUEPRINT_QUESTIONS = 'LOADED_INITIATIVE_BLUEPRINT_QUESTIONS';
export const ERROR_INITIATIVE_BLUEPRINT_QUESTIONS = 'ERROR_INITIATIVE_BLUEPRINT_QUESTIONS';

// UN SDG MAP
export const LOADING_UN_SDG_MAP = 'LOADING_UN_SDG_MAP';
export const LOADED_UN_SDG_MAP = 'LOADED_UN_SDG_MAP';
export const ERROR_UN_SDG_MAP = 'ERROR_UN_SDG_MAP';

// INDUSTRY SECTORS
export const LOADING_INDUSTRY_SECTORS = 'LOADING_INDUSTRY_SECTORS';
export const LOADED_INDUSTRY_SECTORS = 'LOADED_INDUSTRY_SECTORS';
export const ERROR_INDUSTRY_SECTORS = 'ERROR_INDUSTRY_SECTORS';

// CURRENT USER
export const LOADING_CURRENT_USER = 'LOADING_CURRENT_USER';
export const LOADED_CURRENT_USER = 'LOADED_CURRENT_USER';
export const NO_DATA_CURRENT_USER = 'NO_DATA_CURRENT_USER';
export const ERROR_CURRENT_USER = 'ERROR_CURRENT_USER';

// UNIVERSALTRACKERS
export const LOADING_UNIVERSALTRACKERS = 'LOADING_UNIVERSALTRACKERS';
export const LOADED_UNIVERSALTRACKERS = 'LOADED_UNIVERSALTRACKERS';
export const NO_DATA_UNIVERSALTRACKERS = 'NO_DATA_UNIVERSALTRACKERS';
export const ERROR_UNIVERSALTRACKERS = 'ERROR_UNIVERSALTRACKERS';

// UNIVERSALTRACKERVALUE_DETAILS
export const LOADING_UNIVERSALTRACKERVALUE_DETAILS = 'LOADING_UNIVERSALTRACKERVALUE_DETAILS';
export const LOADED_UNIVERSALTRACKERVALUE_DETAILS = 'LOADED_UNIVERSALTRACKERVALUE_DETAILS';
export const UNLOAD_UNIVERSALTRACKERVALUE_DETAILS = 'UNLOAD_UNIVERSALTRACKERVALUE_DETAILS';
export const ERROR_UNIVERSALTRACKERVALUE_DETAILS = 'ERROR_UNIVERSALTRACKERVALUE_DETAILS';

// ONBOARDING_TOKEN
export const LOADING_ONBOARDING_TOKEN = 'LOADING_ONBOARDING_TOKEN';
export const LOADED_ONBOARDING_TOKEN = 'LOADED_ONBOARDING_TOKEN';
export const ERROR_ONBOARDING_TOKEN = 'ERROR_ONBOARDING_TOKEN';

// UNIVERSALTRACKERGROUPS
export const LOADING_UNIVERSALTRACKERGROUPS = 'LOADING_UNIVERSALTRACKERGROUPS';
export const LOADED_UNIVERSALTRACKERGROUPS = 'LOADED_UNIVERSALTRACKERGROUPS';
export const NO_DATA_UNIVERSALTRACKERGROUPS = 'NO_DATA_UNIVERSALTRACKERGROUPS';
export const ERROR_UNIVERSALTRACKERGROUPS = 'ERROR_UNIVERSALTRACKERGROUPS';

// UNIVERSALTRACKERVALUES
export const LOADING_UNIVERSALTRACKERVALUES = 'LOADING_UNIVERSALTRACKERVALUES';
export const LOADED_UNIVERSALTRACKERVALUES = 'LOADED_UNIVERSALTRACKERVALUES';
export const NO_DATA_UNIVERSALTRACKERVALUES = 'NO_DATA_UNIVERSALTRACKERVALUES';
export const ERROR_UNIVERSALTRACKERVALUES = 'ERROR_UNIVERSALTRACKERVALUES';

// UNIVERSALTRACKER_MODAL
export const LOADING_UNIVERSALTRACKER_MODAL = 'LOADING_UNIVERSALTRACKER_MODAL';
export const LOADED_INFO_UNIVERSALTRACKER_MODAL = 'LOADED_INFO_UNIVERSALTRACKER_MODAL';

export const LOADED_HISTORY_UNIVERSALTRACKER_MODAL = 'LOADED_HISTORY_UNIVERSALTRACKER_MODAL';
export const LOADING_HISTORY_UNIVERSALTRACKER_MODAL = 'LOADING_HISTORY_UNIVERSALTRACKER_MODAL';

export const NO_DATA_UNIVERSALTRACKER_MODAL = 'NO_DATA_UNIVERSALTRACKER_MODAL';
export const ERROR_UNIVERSALTRACKER_MODAL = 'ERROR_UNIVERSALTRACKER_MODAL';
export const OPEN_UNIVERSALTRACKER_MODAL = 'OPEN_UNIVERSALTRACKER_MODAL';
export const CLOSE_UNIVERSALTRACKER_MODAL = 'CLOSE_UNIVERSALTRACKER_MODAL';


// SURVEYS LIST SUMMARY
export const LOADING_SURVEY_LIST_SUMMARY = 'LOADING_SURVEY_LIST_SUMMARY';
export const UNLOADING_SURVEY_LIST_SUMMARY = 'UNLOADING_SURVEY_LIST_SUMMARY';
export const LOADED_SURVEY_LIST_SUMMARY = 'LOADED_SURVEY_LIST_SUMMARY';
export const ERROR_SURVEY_LIST_SUMMARY = 'ERROR_SURVEY_LIST_SUMMARY';
export const UPDATE_SURVEY_LIST_SUMMARY = 'UPDATE_SURVEY_LIST_SUMMARY';

// SURVEYS ACTIONS
export const LOADING_SURVEY_ACTIONS = 'LOADING_SURVEY_ACTIONS';
export const LOADED_SURVEY_ACTIONS = 'LOADED_SURVEY_ACTIONS';
export const UNLOAD_SURVEY_ACTIONS = 'UNLOAD_SURVEY_ACTIONS';
export const ERROR_SURVEY_ACTIONS = 'ERROR_SURVEY_ACTIONS';

// SCORECARD
export const LOADING_SCORECARD = 'LOADING_SCORECARD';
export const LOADED_SCORECARD = 'LOADED_SCORECARD';
export const ERROR_SCORECARD = 'ERROR_SCORECARD';

// SCORECARD_SURVEY
export const LOADING_SCORECARD_SURVEY = 'LOADING_SCORECARD_SURVEY';
export const LOADED_SCORECARD_SURVEY = 'LOADED_SCORECARD_SURVEY';
export const ERROR_SCORECARD_SURVEY = 'ERROR_SCORECARD_SURVEY';

// PEER COMPARISON
export const LOADING_PEER_COMPARISON = 'LOADING_PEER_COMPARISON';
export const LOADED_PEER_COMPARISON = 'LOADED_PEER_COMPARISON';
export const ERROR_PEER_COMPARISON = 'ERROR_PEER_COMPARISON';

// SCORECARD LIST
export const UNLOAD_SCORECARD_LIST = 'UNLOAD_SCORECARD_LIST';
export const LOADING_SCORECARD_LIST = 'LOADING_SCORECARD_LIST';
export const LOADED_SCORECARD_LIST = 'LOADED_SCORECARD_LIST';
export const ERROR_SCORECARD_LIST = 'ERROR_SCORECARD_LIST';

// METRIC_UNITS
export const LOADING_METRIC_UNITS = 'LOADING_METRIC_UNITS';
export const LOADED_METRIC_UNITS = 'LOADED_METRIC_UNITS';
export const NO_DATA_METRIC_UNITS = 'NO_DATA_METRIC_UNITS';
export const ERROR_METRIC_UNITS = 'ERROR_METRIC_UNITS';

// Tour
export const OPEN_TOUR = 'OPEN_TOUR';
export const CLOSE_TOUR = 'CLOSE_TOUR';

// Welcome
export const OPEN_WELCOME_MODAL = 'OPEN_WELCOME_MODAL';
export const CLOSE_WELCOME_MODAL = 'CLOSE_WELCOME_MODAL';
